const VariablesPanel = require('../components/variablespanel.js')
const CodePanel = require('../components/codepanel.js')
const GlitchDropAreas = require('../components/glitchdropareas.js')
const SpriteDropAreas = require('./spritedropareas.js')
const html = require('choo/html')
module.exports = function GameContext (state, emit) {
  let secondaryPanel
  if (state.isFullscreen) {
    secondaryPanel = null
  } else {
    if (state.draggingGlitchApplication) {
      secondaryPanel = GlitchDropAreas(state, emit)
    } else if (state.movingSelectedTarget) {
      secondaryPanel = SpriteDropAreas(state, emit)
    } else {
      secondaryPanel = CodePanel(state, emit)
    }
  }
  return [
    VariablesPanel(state, emit),
    secondaryPanel
  ]
}
